var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5003 1.66699C5.90866 1.66699 2.16699 5.40866 2.16699 10.0003C2.16699 14.592 5.90866 18.3337 10.5003 18.3337C15.092 18.3337 18.8337 14.592 18.8337 10.0003C18.8337 5.40866 15.092 1.66699 10.5003 1.66699ZM14.4837 8.08366L9.75866 12.8087C9.64199 12.9253 9.48366 12.992 9.31699 12.992C9.15032 12.992 8.99199 12.9253 8.87532 12.8087L6.51699 10.4503C6.27532 10.2087 6.27532 9.80866 6.51699 9.56699C6.75866 9.32532 7.15866 9.32532 7.40032 9.56699L9.31699 11.4837L13.6003 7.20033C13.842 6.95866 14.242 6.95866 14.4837 7.20033C14.7253 7.44199 14.7253 7.83366 14.4837 8.08366Z",
    fill: "#00AE07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.44957a685e44039d2a54b357298adf2a.svg";
export { ForwardRef as ReactComponent };